module.exports = __webpack_public_path__ + "static/main-61e83fa4be9c792491df29a6bc6e3137.png";